import { render, staticRenderFns } from "./post-category-table.vue?vue&type=template&id=883e4fde&scoped=true&"
import script from "./post-category-table.ts?vue&type=script&lang=ts&"
export * from "./post-category-table.ts?vue&type=script&lang=ts&"
import style0 from "./post-category-table.scss?vue&type=style&index=0&id=883e4fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883e4fde",
  null
  
)

export default component.exports